import React, { useState } from 'react';
import { Stack, Typography } from '@mui/material';
import { TruncatedTooltipText } from '../../../components/uiComponents/TruncatedTooltipText';
import { formatTaxId, maskTaxId } from '../../../utils/commonUtilities';
import { baseColors } from '../../../Themes/colors';
var MaskedSsnValue = function (_a) {
    var value = _a.value, _b = _a.kind, kind = _b === void 0 ? 'ssn' : _b;
    var _c = useState(false), isRevealed = _c[0], setIsRevealed = _c[1];
    if (!value) {
        return React.createElement(TruncatedTooltipText, { value: "--" });
    }
    var formatted = formatTaxId(value, kind);
    return (React.createElement(Stack, { direction: "row", alignItems: "baseline", gap: 1, sx: { minWidth: 0 } },
        React.createElement(TruncatedTooltipText, { value: isRevealed ? formatted : maskTaxId(formatted) }),
        React.createElement(Typography, { component: "button", type: "button", variant: "caption", fontWeight: 600, onClick: function () { return setIsRevealed(function (prev) { return !prev; }); }, sx: {
                flexShrink: 0,
                p: 0,
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                color: baseColors.bluePreset[30],
                textDecoration: 'underline',
                font: 'inherit',
                fontSize: 12,
                fontWeight: 600,
            } }, isRevealed ? 'Hide' : 'View')));
};
export default MaskedSsnValue;
